type FeedbackType = "OrderPositive" | "OrderNegative" | "DeliveryDate"

type FeedbackFormState = {
  title: string
  type: FeedbackType
  cardCode: string
  orderNum: string
  refNum: string
  orderDate: string
  orderDeliveryDate: string
  message: string
  dirty: boolean
}

export type FieldId = "msg"

export let DATFeedback: FeedbackFormState = {
  cardCode: undefined,
  dirty: undefined,
  message: undefined,
  orderDate: undefined,
  orderDeliveryDate: undefined,
  orderNum: undefined,
  refNum: undefined,
  title: undefined,
  type: undefined,
}
